import React from "react";

interface Props {
	children: React.ReactNode;
	defaultDescription: string;
	errorComponent?: React.ReactNode;
}

interface State {
	hasError: boolean;
}

class ErrorBoundary extends React.PureComponent<Props, State> {
	public static defaultProps = {
		defaultDescription: "An unexpected error occured.",
	};

	constructor(props: Props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error: unknown) {
		console.log("WHA", error);
		return { hasError: true };
	}

	// componentDidCatch(error, errorInfo) {
	// ?? Log something to a reporting service?
	// }

	render() {
		if (this.state.hasError) {
			if (this.props.errorComponent) return this.props.errorComponent;
			return (
				<div className="error-boundary">
					<p>{this.props.defaultDescription}</p>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
